import { Box, Flex, Image, Text, Button, VStack } from "@chakra-ui/react";
import { ArrowUpDown } from "lucide-react";


export default function Projects() {
  const hasProjects = false; // you will replace this with real data later

  return (
    <Box mt={10}>

      <Flex justify="space-between" align="center" mb={5}>
        <Text fontSize="20px" fontWeight="600" lineHeight="42px">
          Recent Projects
        </Text>

        <Button
          leftIcon={<ArrowUpDown size={16} color="#242424" strokeWidth={2.5} />}
          border="1px solid transparent"
          borderRadius="12px"
          bg="white"
          _hover={{ bg: "white" }}
          color="#6D6D6D"
          fontSize="md"
          fontWeight="medium"
          px={4}
          py={2}
        >
          Sort by: Time
        </Button>
      </Flex>

      {!hasProjects && (
        <VStack spacing={3} mt={10} textAlign="center" color="#6D6D6D">
          <Image
            src="/empty_notepad.svg"
            alt="Enginering Assistant"
            width="60px"
            // borderRadius="100px"
          />

          <Text fontSize="lg" fontWeight="semibold" color="#111">
            Nothing to show here
          </Text>

          <Text width="45%" fontSize="md">
            Type in search field and attach documents to begin the scans
          </Text>
        </VStack>
      )}
    </Box>
  );
}
